var _defs, _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56.723,
    viewBox: "0 0 56 56.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#384152;}.b{fill:#e6007e;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.354,
    height: 10.656,
    transform: "translate(15.325 15.207)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.354,
    height: 11.728,
    transform: "translate(15.325 29.232)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.8,81.034a9.226,9.226,0,0,1,1.666-3.273,7.057,7.057,0,0,1,2.662-1.987,8.625,8.625,0,0,1,3.462-.678,8.915,8.915,0,0,1,2.627.376,6.764,6.764,0,0,1,2.134,1.059,5.184,5.184,0,0,1,2.1,3.855h3.462a8.49,8.49,0,0,0-1.056-3.4,8.858,8.858,0,0,0-2.268-2.626,10.416,10.416,0,0,0-3.194-1.676,12.068,12.068,0,0,0-3.8-.556,12.362,12.362,0,0,0-4.9.941,10.428,10.428,0,0,0-3.757,2.687,12.23,12.23,0,0,0-2.38,4.192,15.413,15.413,0,0,0-.723,3.313h3.5A13.255,13.255,0,0,1,87.8,81.034Z",
    transform: "translate(-62.281 -57.411)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M84.436,109.645a12.025,12.025,0,0,0,2.372,4.2,10.39,10.39,0,0,0,3.739,2.7,12.43,12.43,0,0,0,4.934.919,12.925,12.925,0,0,0,3.934-.578,9.515,9.515,0,0,0,3.164-1.654,8.51,8.51,0,0,0,2.194-2.709,9.563,9.563,0,0,0,1.026-3.654h-3.462a6.462,6.462,0,0,1-.662,2.433,5.528,5.528,0,0,1-1.441,1.79,6.208,6.208,0,0,1-2.121,1.1,9.232,9.232,0,0,1-2.7.372,8.214,8.214,0,0,1-3.432-.691,7.207,7.207,0,0,1-2.627-2.022,9.228,9.228,0,0,1-1.662-3.286,14.286,14.286,0,0,1-.554-3.269h-3.5A16.352,16.352,0,0,0,84.436,109.645Z",
    transform: "translate(-62.173 -76.068)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42.7,67.732H38.39V64.367H42.7V47.252H81.484V38.5H34.04V86.471H42.7Z",
    transform: "translate(-34.04 -38.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M92.7,58.5h-.1V75.615H96.9V78.98H92.6V97.719H53.81v8.752H92.7l-.052-8.7,8.608-.053V58.5Z",
    transform: "translate(-45.254 -49.748)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.ddaf7806bb3ad6be858a7d5487b5a1a7.svg";
export { ForwardRef as ReactComponent };